

import wxMixin from "../../../../mixins/wx"

import { WECHAT_MP_PRE_PAY } from "../../apis/payment"

export default {
  mixins: [wxMixin],
  methods: {
    // 微信支付前置
    async onWechatPay(payMode, callback) {
      this.$loading(true)
      const query = {
        paymentId: payMode.pId || '',
        qrcode: payMode.payCode || '',
        amount: payMode.payPrice || ''
      }
      let headers = {}
      await this.$Request("post", `${WECHAT_MP_PRE_PAY}`, query, headers).then((resp) => {
        this.$loading(false)
        console.log("wechat pre pay", resp)
        const data = resp.data || {}
        this.loadWXScript(["chooseWXPay"], () => {
          data.payMode = 'wechat'
          data.orderId = data.out_trade_no
          this.wechatPayConfirm(data, callback)
        })
      }).catch((err) => {
        console.log("wechat pre pay error", err)
        this.$loading(false)
        callback && callback({ errMsg: err })
      })
    },
    // 微信支付确认
    wechatPayConfirm(data, callback) {
      const payQuery = {
        appId: data.appId,
        timeStamp: data.timeStamp,
        nonceStr: data.nonceStr,
        package: data.package,
        signType: data.signType,
        paySign: data.paySign
      }
      window.WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        payQuery,
        function (resp) {
          console.log("WeixinJSBridge pay===", resp)
          if (resp.err_msg === "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。

            resp.data = data
            callback && callback(resp)
          } else if (resp.err_msg === "get_brand_wcpay_request:fail") {
            // 支付失败
            resp.errMsg = "支付失败"
            callback && callback(resp)
          }
        }
      )
    }
  },
}
